<template>
    <div class="date-select">
        <div class="data-select-title">Дата расчета</div>
        <tep-lookup
            v-if="args"
            :disabled='!isLookup'
            :value='NagrRasxDdatval'
            :meta='metaDdatval'
            :args="args"
            :data-source='lookupDdatval'
            @selected-value='onSelectDdatval'
        />
    </div>
    <div class="line">
        <table v-if="dataNagrRasxWater">
            <thead>
                <tr align="center">
                    <th colspan="2">Нагрузка [Ккал/час]</th>
                    <th colspan="3">Расход воды [т/час]</th>
                </tr>
            </thead>
            <tbody>
                <tr  align="center">
                    <td class="td"></td>
                    <td class="td"></td>
                    <td class="td">Во внешней сети</td>
                    <td class="td">В линии ГВС</td>
                    <td class="td">Во вторичном контуре</td>
                </tr>
                <tr>
                    <td>Отопление</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_q_so"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_so"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_so_vk"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                </tr>
                <tr>
                    <td>Вентиляция</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_q_sw"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_sw"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_sw_vk"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                </tr>
                <tr>
                    <td>Технология</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_q_st"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_st"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>ГВС max</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_q_gwm"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_gs_gw"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_qwm"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>ГВС ср.час.</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_q_gw_sr"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_gs_gwsr"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_gwsr"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>Сут расход</td>
                    <td></td>
                    <td></td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_g_gwsut"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td>Теплопотери</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_nagrpot"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_rasxpot"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Сумма с ГВС max</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_qs_gwm"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Сумма с ГВС ср.час.</td>
                    <td>
                        <ai-form-number-box-readonly
                            :meta='{fieldNameText: "sum_qs_gwsr"}'
                            :server-data='dataNagrRasxWater'
                        ></ai-form-number-box-readonly>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="line">
        <table v-if="dataNagrRasxWater">
            <tr>
                <td class="td">Макс расход воды в ОС</td>
                <td class="td">[т/час]</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_os"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_os_gw"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_os_vk"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Макс расход воды в МОС</td>
                <td>[т/час]</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_ms"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_ms_gw"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_ms_vk"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Ср.час. расход воды в ОС</td>
                <td>[т/час]</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_os"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_os_gw"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_os_vk"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Ср.час. расход воды в МОС</td>
                <td>[т/час]</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_ms"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_ms_gw"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_ms_vk"}'
                        :server-data='dataNagrRasxWater'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    name: 'widget-nagr-rasx-water',
}
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import tepService from '@/service/tep-service';
import TepLookup from '@/views/tep/tep-nsi/components/tep-lookup.vue';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

const props = defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
    action: {
        type: Function,
        default: null,
    },
});

const NagrRasxDdatval = ref(null);
const lookupDdatval = ref(null);
const dataNagrRasxWater = ref(null);
const args =ref(null);

onMounted(async() => {
    args.value = {
        kod_vid: props.userData.kod_vid,
        kod_sx:  props.userData.kod,
    }
    NagrRasxDdatval.value = await tepService.getNagrRasxDdatval(args.value);
    lookupDdatval.value = await  tepService.getLookupDdatval(args.value);
    if(NagrRasxDdatval.value === null && lookupDdatval.value.length) {
        NagrRasxDdatval.value = lookupDdatval.value?.[0].kod;
    }
    await getDataNagrRasxWater();
});

const isLookup = computed(() => {
    return [50, 22510000].includes(props.userData.kod_vid);
})

const onSelectDdatval = async (data) => {
    if(NagrRasxDdatval.value === data) return;
    NagrRasxDdatval.value = data;
    await getDataNagrRasxWater();
}

const getDataNagrRasxWater = async () => {
    dataNagrRasxWater.value = await tepService.getNagrRasxWater({...args.value, kod_ddatval: NagrRasxDdatval.value});
}

const metaDdatval = {
    keyExpr: 'kod',
    api: {
        select: 'tep-grid./tep/widgets/lookup-ddatval/get'
    },
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod",
    hasntRoute: true,
    columns: [
        {
            caption: '',
            name: 'kod',
            dataField: 'kod',
            visible: false,
            width: 50,
            index: 1,
        },
        {
            caption: '',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 2,
            allowFiltering: false
        },
    ],
    viewId: "lookup-ddatval"

}

</script>
<style scoped>
    .date-select {
        display: flex;
        align-items: center;
        gap: 8px;
        padding-bottom: 16px;
    }
    .data-select-title {
        white-space: nowrap;
    }
    .line {
        padding: 16px 0;
        border-top: 2px solid rgba(191, 191, 191, .7);
    }
    .td {
        min-width: 200px;
    }
    td, th {
        padding: 5px 10px;
    }
    td :deep(.dx-field-label) {
        display: none;
    }
    :root:root td :deep(.dx-field-value) {
        width: 100%;
    }
</style>
